import React from "react";
import FlowContainer from "../../components/FlowContainer";
import { brandclub_colors } from "@brandclub/common-ui";

import {
  FlowSolidButton,
  FlowSolidButtonGrey,
} from "../../components/FlowButtons";
import ReviewSelectPill from "../components/ReviewSelectPill";
import {
  ReviewInfo,
  ReviewQuestionContainer,
  ReviewSection,
  ReviewSelections,
  ReviewSubtitle,
  ReviewTitle,
} from "../components/ReviewStyledComponents";
import Loading from "../../../../../Loading";
import ProductHeader from "../components/ProductHeader";
import { FlowActionButtonsGroup } from "../../components/FlowStyledComponents";
import { Box } from "@mui/material";

type ConsPageProps = {
  product: any;
  setSelectedOptions: React.Dispatch<React.SetStateAction<string[]>>;
  selectedOptions: string[];
  options: string[];
  moveBack: () => void;
  moveNext: () => void;
};

const Cons = ({
  product,
  options,
  selectedOptions,
  setSelectedOptions,
  moveBack,
  moveNext,
}: ConsPageProps) => {
  const handleSelect = (option: string) => {
    if (selectedOptions.includes(option)) {
      setSelectedOptions(selectedOptions.filter((o) => o !== option));
    } else {
      setSelectedOptions([...selectedOptions, option]);
    }
  };

  const hasSelectedOptions = selectedOptions.length > 0;
  return (
    <FlowContainer style={{ background: brandclub_colors.white }}>
      <ReviewQuestionContainer>
        <ReviewInfo>
          <ProductHeader product={product} />
          <ReviewSection>
            <ReviewTitle>What features need improved?</ReviewTitle>
            <ReviewSubtitle>Select all that apply</ReviewSubtitle>
            <ReviewSelections>
              {options?.length ? (
                options.map((option) => {
                  const selected = selectedOptions?.includes(option);
                  return (
                    <ReviewSelectPill
                      key={option}
                      selected={selected}
                      text={option}
                      onClick={() => {
                        handleSelect(option);
                      }}
                    />
                  );
                })
              ) : (
                <Box width="100%">
                  <Loading dot />
                </Box>
              )}
            </ReviewSelections>
          </ReviewSection>
        </ReviewInfo>
        <FlowActionButtonsGroup>
          <FlowSolidButtonGrey onClick={moveBack}>Back</FlowSolidButtonGrey>
          <FlowSolidButton onClick={moveNext}>
            {hasSelectedOptions ? "Next" : "Skip"}
          </FlowSolidButton>
        </FlowActionButtonsGroup>
      </ReviewQuestionContainer>
    </FlowContainer>
  );
};

export default Cons;
